import { useEffect, useState } from "react";
import Modal from "../../../../../../components/ui/Modal/Modal";
import Button from "../../Components/Button";
import QRInfoTable from "./QRInfoTable";
import { ImArrowRight } from "react-icons/im";
import ResultTableOtherRelease from "./ResultTableOtherRelease";
import QuantityTableOtherRelease from "./QuantityTableOtherRelease";
import { LotDataByIdTable } from "../ManualChange/lot-data-by-id-table";
import { useLotDataById } from "../../../../../../api/inventory/use-lot-data";
import { useUpdateProductLots } from "../../../../../../api/inventory/use-update-lot";

function SortModal({
  onChangeSelectQR,
  onSubmitQR,
  isEmpty,
  getDataTableProps,
  selectedQR,
  onCloseModal,
}) {
  const totalQty = getDataTableProps().data?.reduce((a, b) => a + b.qnt, 0);

  return (
    <div className="w-[46rem]">
      <div className="flex items-center justify-between pb-[8px] border-b border-b-primary-grey">
        <h1 className="text-[16px] px-5 font-bold">QR 스캔 결과</h1>
        <div className="flex items-center">
          <p className="mr-5">※ 출고 처리할 재고를 선택해 주세요.</p>
          <button
            onClick={onCloseModal}
            className="border mr-2 px-6 py-1 border-button-grey rounded-[4px]"
          >
            취소
          </button>
          <button
            onClick={onSubmitQR}
            className="border mr-5 px-6 py-1 border-primary-blue bg-primary-blue text-white rounded-[4px]"
          >
            선택 완료
          </button>
        </div>
      </div>
      <div className="px-5 pb-2">
        <div className="border mt-4 py-2 px-4 text-white border-primary-blue bg-primary-blue">
          재고정보 (현재 재고수량 : {totalQty}개)
        </div>

        <LotDataByIdTable
          isEmpty={isEmpty}
          getDataTableProps={getDataTableProps}
          onChangeSelectQR={onChangeSelectQR}
          selectedQR={selectedQR}
        />
      </div>
    </div>
  );
}

export const QRModal = ({
  onCloseModal,
  setTriggerCloseModal,
  productData,
  prodId,
  currentStockQty,
}) => {
  const { isEmpty, getDataTableProps } = useLotDataById({}, prodId);
  const [selectedQR, setSelectedQR] = useState();
  const [qty, setQty] = useState(0);
  const [showQR, setShowQR] = useState();
  const { mutate: updateProductLots } = useUpdateProductLots();
  const showedData = getDataTableProps().data?.find((val) => val.id === showQR);
  const qtyAfterDelivery = +showedData?.qnt - +qty;
  const currentStockAfterDelivery = +currentStockQty - +qty;
  const [triggerCloseModalSort, setTriggerCloseModalSort] = useState(false);
  const [description, setDescription] = useState("");
  const isSubmitDisable =
    qty === 0 || !qty || qty > showedData?.qnt || description === "";

  useEffect(() => {
    if (triggerCloseModalSort === true) {
      setTriggerCloseModalSort(false);
    }
  }, [triggerCloseModalSort]);

  const onChangeDescription = (e) => {
    setDescription(e.target.value);
  };

  const onCloseModalSort = () => {
    setTriggerCloseModalSort(true);
  };

  const onSubmitQR = () => {
    setShowQR(selectedQR);
    setTriggerCloseModalSort(true);
  };

  const onChangeSelectQR = (id) => {
    setSelectedQR(id);
  };

  const onChangeQty = (e) => {
    setQty(e.target.value);
  };

  const handleSubmit = async () => {
    if (!isSubmitDisable) {
      await updateProductLots({
        id: showedData?.id,
        qnt: qtyAfterDelivery,
        qntType: "OUT",
        description: description,
      });
      setTriggerCloseModal(true);
    }
  };

  return (
    <div className="mx-auto">
      <div className="flex items-center justify-between pb-[8px] border-b border-b-primary-grey">
        <h1 className="text-[16px] px-5 font-bold">기타 출고 처리</h1>
        <div>
          <button
            onClick={onCloseModal}
            className="border mr-2 px-6 py-1 border-button-grey rounded-[4px]"
          >
            취소
          </button>
          <button
            onClick={handleSubmit}
            disabled={isSubmitDisable}
            className={`border mr-5 px-6 py-1 border-button-grey ${
              isSubmitDisable ? "text-disable-black" : "text-white"
            } ${
              isSubmitDisable ? "bg-disable-grey" : "bg-primary-blue"
            } rounded-[4px]`}
          >
            출고 완료
          </button>
        </div>
      </div>
      <div className="px-5 py-4">
        <div>
          <div className="border py-2 px-4 text-white border-primary-blue bg-primary-blue">
            상품정보
          </div>
          <div className="flex w-full">
            <div className="flex w-[50%]">
              <h1
                className={`border py-2 w-28 px-4 border-r-0 border-disable-grey bg-input-grey flex-none`}
              >
                카테고리
              </h1>
              <div className="flex items-center border-disable-grey px-2 outline-none border-r-0 border w-full">
                {productData?.productGroup?.productGroupCategory?.name}
              </div>
            </div>
            <div className="flex w-[50%]">
              <h1 className="border py-2 w-28 px-4 border-r-0 border-disable-grey bg-input-grey flex-none">
                REF(상품코드)
              </h1>
              <div className="flex items-center border-disable-grey px-2 outline-none w-full border">
                {productData?.ref}
              </div>
            </div>
          </div>
          <div className="flex w-full">
            <h1 className="border border-t-0 py-2 w-28 flex-none px-4 border-r-0 border-disable-grey bg-input-grey">
              상품명
            </h1>
            <div className="flex items-center border-disable-grey border-t-0 px-2 outline-none w-full border">
              {productData?.name}
            </div>
          </div>
        </div>
        <div className="w-full mt-4">
          <Modal
            maxWidth="max-w-fit"
            description={
              <SortModal
                onSubmitQR={onSubmitQR}
                onChangeSelectQR={onChangeSelectQR}
                isEmpty={isEmpty}
                getDataTableProps={getDataTableProps}
                selectedQR={selectedQR}
                onCloseModal={onCloseModalSort}
              />
            }
            hasCancel={false}
            hasSubmit={false}
            hasClose={false}
            triggerClose={triggerCloseModalSort}
          >
            <Button
              backgroundColor={`bg-drop-yellow border border-drop-yellow`}
              fontWeight={`font-bold text-sm`}
              padding={`py-2 `}
              width={`w-full`}
              titleButton={`QR 스캔`}
            />
          </Modal>
        </div>
      </div>
      {showQR ? (
        <div className="mt-2 border-t-8 border-line-grey px-5">
          <div className="mt-4">
            <div className="p-2 bg-primary-blue text-white font-bold">
              QR 스캔 정보
            </div>
            <QRInfoTable data={showedData} currentStockQty={currentStockQty} />
          </div>
          <div className="mt-2">
            <h2 className="text-[14px] font-bold">■ 적용 결과</h2>
            <div className="flex items-center gap-4 mt-2">
              <div className="w-[40%]">
                <ResultTableOtherRelease
                  qty={qty}
                  onChangeQty={onChangeQty}
                  currentQty={showedData?.qnt}
                />
              </div>
              <ImArrowRight className="text-[42px]" />
              <div className="w-[60%]">
                <QuantityTableOtherRelease
                  qtyAfterDelivery={qtyAfterDelivery}
                  currentStockAfterDelivery={currentStockAfterDelivery}
                />
              </div>
            </div>
            <span className="mt-3">
              ※ 재고수량 범위내에서만 입력 가능합니다.
            </span>
            <div className="flex border border-[#dddddd] mt-4">
              <div className="w-[30%] p-2 bg-[#f2f2f4]">내역 메모</div>
              <div className="w-[70%] p-2 ">
                <input
                  type="text"
                  className="w-full outline-none px-2 pr-12"
                  value={description}
                  onChange={onChangeDescription}
                  placeholder="(필수) 기타 출고 처리되는 재고분에 대하여 간략히 메모를 해주세요."
                />
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="mt-2 border-t-8 border-line-grey px-5">
          <div className="text-title-grey justify-center pt-20 pb-28 flex items-center">
            출고 상품의 QR을 스캔해주세요.
          </div>
          <div className="text-title-grey pb-4">
            <p className="font-bold">※ 사용방법 안내</p>
            <p>
              1. QR 스캔을 누룬 후, USB 바코드 스캐너를 통하여 '입고 상품의
              QR'을 스캔해주세요.
            </p>
            <p>
              2. QR 스캔이 일치되면, 해당 REF에 연동된 'QR 스캔 정보'가
              나옵니다.
            </p>
            <p>3. 적용 결과에 출고수량을 정확히 입력해주세요. </p>
            <p>
              4. 출고된 수량을 잘못 입력할 경우, 해당 LOT 재고는 '재고 수동
              변경'을 통해 재고 수량을 조정할 수 있습니다.
            </p>
            <p>단, 현재 단계에서 신중히 입력 부탁드립니다.</p>
          </div>
        </div>
      )}
    </div>
  );
};
